import { createSlice } from "@reduxjs/toolkit";

export const omitir1Slice = createSlice({
  name: "omitir1",
  initialState: {
    omitir1: false,
  },
  reducers: {
    omitir1Add: (state, action) => {
      state.omitir1 = action.payload;
    },
  },
});

export const { omitir1Add } = omitir1Slice.actions;
export default omitir1Slice.reducer;

